module.exports = __webpack_public_path__ + "static/media/DGAC_Dashboard_Page_Header.5345003f.jpg";